import { ComponentType } from 'react';
import {
  XIcon,
  PencilIcon,
  Trash2Icon,
  SettingsIcon,
  DownloadIcon,
  UploadIcon,
  MaximizeIcon,
  Share2Icon,
  CopyIcon,
  FilterIcon,
  MoreHorizontalIcon,
  PhoneIcon,
  MessageSquareIcon,
  XCircleIcon,
  CheckIcon,
  CheckCircleIcon,
  PlusIcon,
  LayoutGridIcon,
  MailIcon,
  HelpCircleIcon,
  SparklesIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  WandSparklesIcon,
  SearchIcon,
  RefreshCwIcon,
  ClockIcon,
  EyeIcon,
  StarIcon,
} from 'lucide-react';
import { IconType } from '../types';

export const ICON_TYPE_MAP: Record<IconType, ComponentType<{ className?: string }>> = {
  [IconType.X]: XIcon,
  [IconType.PENCIL]: PencilIcon,
  [IconType.TRASH_CAN]: Trash2Icon,
  [IconType.GEAR]: SettingsIcon,
  [IconType.DOWNLOAD]: DownloadIcon,
  [IconType.UPLOAD]: UploadIcon,
  [IconType.EXPAND]: MaximizeIcon,
  [IconType.SHARE]: Share2Icon,
  [IconType.COPY]: CopyIcon,
  [IconType.FILTER]: FilterIcon,
  [IconType.THREE_DOTS]: MoreHorizontalIcon,
  [IconType.CALL]: PhoneIcon,
  [IconType.WRITE_MESSAGE]: MessageSquareIcon,
  [IconType.CANCEL]: XCircleIcon,
  [IconType.APPLY]: CheckIcon,
  [IconType.DONE]: CheckCircleIcon,
  [IconType.PLUS]: PlusIcon,
  [IconType.MENU]: LayoutGridIcon,
  [IconType.EMAIL]: MailIcon,
  [IconType.HELP]: HelpCircleIcon,
  [IconType.AI]: SparklesIcon,
  [IconType.PREV]: ChevronLeftIcon,
  [IconType.NEXT]: ChevronRightIcon,
  [IconType.MAGIC]: WandSparklesIcon,
  [IconType.MAGNIFYING]: SearchIcon,
  [IconType.REFRESH]: RefreshCwIcon,
  [IconType.CLOCK]: ClockIcon,
  [IconType.EYE]: EyeIcon,
  [IconType.STAR]: StarIcon,
  [IconType.STAR_SELECTED]: StarIcon,
};
